import { CommonService } from 'shared/services/common.service';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { PreloaderService } from '../../services/preloader.service';
import { InvoiceApi, PurchaseOrderApi } from '../../sdk';
import { isMoment } from '../../../../node_modules/moment';

@Component({
    selector: 'app-invc-detail',
    templateUrl: './invc-detail.component.html',
    styleUrls: ['./invc-detail.component.css']
})

export class InvcDetailComponent implements OnInit {

    @Input() modelName: string;
    @Input() modelId: string;
    @Input() IsActiveLink: string;

    invoice: any;
    order: any;
    errorMessage: string;
    timeZone: any;
    purchaseInvoiceTab: boolean = true;

    constructor(
        private invoiceApi: InvoiceApi,
        private purchaseOrderApi: PurchaseOrderApi,
        private preloaderService: PreloaderService,
        private _commonService: CommonService
    ) { }

    ngOnInit() {
        this._commonService.getUserProfile().subscribe(userProfile => {
            if (userProfile) {
                this.timeZone = userProfile['timezone'];
            }
        }, error => {
            console.log(error);
        })

        if (this.modelName.toLowerCase() === 'invoice') {
            this.getInvoiceDetails({ sfdcId: this.modelId });
        }

        if (this.modelName.toLowerCase() === 'job' && this.modelId) {
            this.preloaderService.showPreloader();
            this.errorMessage = '';
            this.purchaseOrderApi.find({
                where: { Service_Dispatch__c: this.modelId },
                fields: { sfdcId: true }
            }).subscribe(order => {
                if (order && order.length) {
                    this.order = order[0];
                    this.getInvoiceDetails({ Purchase_Order__c: this.order.sfdcId });
                } else {
                    this.errorMessage = 'No invoice details found.';
                }
                this.preloaderService.hidePreloader();
            }, err => {
                this.errorMessage = err.message;
                this.preloaderService.hidePreloader();
            });
        }
    }

    getInvoiceDetails(query: any) {
        this.preloaderService.showPreloader();
        this.errorMessage = '';
        this.invoiceApi.find({
            include: [
                { relation: 'vendor', scope: { fields: { Name: true } } },
                {
                    relation: 'purchaseOrder',
                    scope: {
                        fields: { sfdcId: true, Service_Dispatch__c: true },
                        include: ['job',
                            { relation: 'lineItems', scope: { limit: 1 } },
                        ]
                    }
                },
                { relation: 'timecard' }
            ],
            where: query
        }).subscribe(
            invoice => {
                if (invoice && invoice.length) {
                    this.invoice = invoice[0];
                    let inDate = new Date(this.invoice['Vendor_Timecard_Actual_In__c']).toString();
                    let outDate = new Date(this.invoice['Vendor_Timecard_Actual_Out__c']).toString();
                    if (inDate == 'Invalid Date') {
                        this.invoice['Vendor_Timecard_Actual_In__c'] = '';
                    }
                    if (outDate == 'Invalid Date') {
                        this.invoice['Vendor_Timecard_Actual_Out__c'] = '';
                    }

                } else {
                    this.errorMessage = 'No invoice details found.';
                }
                this.preloaderService.hidePreloader();
            }, error => {
                this.errorMessage = error.message;
                this.preloaderService.hidePreloader();
            }
        );
    }

}
